import React from 'react';
import { 
  Container, 
  Row, 
  Col, 
  Modal, 
  ModalHeader, 
  ModalBody, 
  ModalFooter, 
  Button, 
  Label, 
  FormGroup, 
  Input, 
  Alert 
} from 'reactstrap';
import Datetime from "react-datetime";
import Async from 'react-select/async';
import Select from 'react-select';
import moment from 'moment';
// Components
import CurrencyInput from 'components/CurrencyInput/CurrencyInput';
// Helpers
import { formatPrice } from 'helpers/pricing';
// Requests
import { getClientsRequest } from 'api/client';
import { getUnitBalanceRequest } from 'api/units';
// Contexts
import ProjectContext from 'contexts/ProjectContext';

class TransferUnitModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			modal: false,
			unit: {},
			selectedClient: null,
			remainingAmount: null,
			paidAmount: null,
			transferFeeCompleted: false,
			transferFeePaymentDate: null,
			selectedBPSubtype: null,
			totalBalancePaymentMonths: null,
			loanInterest: 0,
			balancePaymentDate: null,
			firstCheckNumber: null,
			newTcp: null,
			totalDownPaymentMonths: null,
			firstDownPaymentDate: null,
			firstPrincipalCheckNumber: null,
			firstMiscCheckNumber: null,
			firstRentalCheckNumber: null,
			firstPrincipalBankName: null,
			firstMiscBankName: null,
			firstRentalBankName: null,
			principalAmount: null,
			miscelaneousAmount: null,
			rentalAmount: null,
			balanceAmount: null,
		};
		this.toggle = this.toggle.bind(this);
	}

  	static contextType = ProjectContext;

	async toggle() {
		const { models = [], selectedModel, client, _id } = this.props.selectedUnit
		let modelsIndex = models.findIndex(x => x.name === selectedModel.name)
			
		const response = await getUnitBalanceRequest(_id);
		const remainingAmount = response.totalRemaining;
		const paidAmount = response.totalPaid;
		this.setState({
			paidAmount,
			remainingAmount,
			modal: !this.state.modal,
			unit: {
				...this.props.selectedUnit,
				client
			},
			modelsIndex,
			selectedClient: null,
			transferFeeCompleted: false,
			transferFeePaymentDate: null,
			selectedBPSubtype: null,
			totalBalancePaymentMonths: null,
			loanInterest: 0,
			balancePaymentDate: null,
			firstCheckNumber: null,
			newTcp: null
		});
	}

  	onChangeField = (e) => {
		const { target } = e;
		let { name, value } = target;

		if (name === "newTcp") {
			const newBalanceAmount = value - this.state.paidAmount;
			this.setState({
				remainingAmount: newBalanceAmount
			})
		}

        this.setState({
            [name]: value,
        })
	}

	loadClients = async (search, callback) => {
    	const { selectedProject } = this.context;

		const clientFilters = {
			project: selectedProject,
			search,
			status: 'available'
		}

		if(search) {
			const clientResponse = await getClientsRequest(clientFilters);
			const clients = clientResponse.clients.map(client => {
				return {
					data: client,
					label: `${client.first_name} ${client.last_name}`,
					value: client._id
				}
			})
			callback(clients);
		}
	}

	onSelectChange = (key) => (object) => {
		this.setState(() => ({
			[key]: object
		}));
	}

  	render() {
		const { 
			backdrop = false,
			onSave,
			loading,
			error,
		} = this.props;

		const {
			client
		} = this.state.unit;

		const {
			unit,
			selectedClient,
			remainingAmount,
			paidAmount,
			transferFeeCompleted,
			transferFeePaymentDate,
			transferFeeAmount,
			selectedBPSubtype,
			totalBalancePaymentMonths,
			loanInterest,
			balancePaymentDate,
			firstCheckNumber,
			newTcp,
			totalDownPaymentMonths,
			firstDownPaymentDate,
			firstPrincipalCheckNumber,
			firstMiscCheckNumber,
			firstRentalCheckNumber,
			firstPrincipalBankName,
			firstMiscBankName,
			firstRentalBankName,
			principalAmount,
			miscelaneousAmount,
			rentalAmount,
			balanceAmount,
		} = this.state;

		const saveData = {
			unit,
			newClientId: selectedClient && selectedClient.value,
			previousClientId: client && client._id,
			paidAmount,
			remainingAmount,
			transferFeeCompleted,
			transferFeePaymentDate: transferFeeCompleted ? transferFeePaymentDate : null,
			transferFeeAmount,
			selectedBPSubtype,
			totalBalancePaymentMonths,
			loanInterest,
			balancePaymentDate,
			firstCheckNumber,
			newTcp,
			totalDownPaymentMonths,
			firstDownPaymentDate,
			firstPrincipalCheckNumber,
			firstMiscCheckNumber,
			firstRentalCheckNumber,
			firstPrincipalBankName,
			firstMiscBankName,
			firstRentalBankName,
			principalAmount,
			miscelaneousAmount,
			rentalAmount,
			balanceAmount,
		}

    return (
      <Modal backdrop={backdrop} className="cancel-reservation" isOpen={this.state.modal} toggle={this.toggle} style={{marginTop: '-120px'}}>
        <ModalHeader toggle={this.toggle}>Transfer Unit</ModalHeader>
        <ModalBody>
          	<Container className="p-2">
				<Row>
					<Col>
						<FormGroup>
						<Label>Old Client<span className="required-start">*</span></Label>
						<Input
							name="client"
							type="text"
							value={client ? `${client.first_name} ${client.last_name}` : "N/A"}
							disabled
						/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col sm={12}>
						<FormGroup>
							<Label>Old TCP<span className="required-start">*</span></Label>
							<Input
							name="models"
							type="text"
							value={formatPrice(unit?.selectedModel?.tcp ?? 0) || "N/A"}
							disabled
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col>
						<FormGroup>
						<Label>Amount Paid<span className="required-start">*</span></Label>
						<Input
							name="paidAmount"
							type="text"
							value={(paidAmount || paidAmount === 0) ? `PHP ${formatPrice(paidAmount)}` : "PHP 0.00"}
							disabled
						/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col sm={12}>
						<FormGroup>
							<Label>New TCP</Label>
							<CurrencyInput 
								name="newTcp"
								price={newTcp || 0}
								onChange={(value) => this.onChangeField({ target: { name: "newTcp", value } })}
								placeholder=""
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col>
						<FormGroup>
							<Label>Amount Remaining<span className="required-start">*</span></Label>
							<Input
								name="remainingAmount"
								type="text"
								value={(remainingAmount || remainingAmount === 0) ? `PHP ${formatPrice(remainingAmount)}` : "PHP 0.00"}
								disabled
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col>
						<FormGroup>
							<Label>New Client <span className="required-start">*</span></Label>
							<Async
								clearValue={""}
								value={selectedClient}
								options={[]}
								loadOptions={this.loadClients}
								className="basic-multi-select "
								classNamePrefix="select"
								onChange={(selectedClient) => this.setState({ selectedClient })}
								placeholder="Client..."
								isClearable={true}
							/>
							<span className="form-text text-dark">
								{`Only clients with status available will be shown`}
							</span>
						</FormGroup>
					</Col>
				</Row>
				<h3 className="text-dark mt-3 mb-0">Transfer Fee</h3>
				<Row>
                  <Col sm={12}>
                    <FormGroup>
                      <Label>Transfer Fee Amount</Label>
                      <CurrencyInput 
                        name="transferFeeAmount"
                        price={transferFeeAmount || 0}
                        onChange={(value) => this.onChangeField({ target: { name: "transferFeeAmount", value } })}
                        placeholder=""
                      />
                    </FormGroup>
                  </Col>
				</Row>
				<Row>
					<Col>
						<FormGroup check className="my-2">
							<Label check>
								<Input 
										type="checkbox"
										name="transferFeeCompleted"
										onChange={(e) => this.setState({ transferFeeCompleted: e.target.checked })}
										checked={transferFeeCompleted}
								/>
								<span className="form-check-sign" />
								Transfer fee is completed
							</Label>
						</FormGroup>
					</Col>
				</Row>
				<Row>
				<Col>
					<FormGroup>
						<Label>Transfer Fee Payment Date</Label>
						<Datetime
							inputProps={{
								className: "form-control",
								placeholder: "Settlement Payment Date",
								name: "transferFeePaymentDate"
							}}
							dateFormat="MM/DD/YYYY"
							timeFormat={false}
							value={transferFeePaymentDate}
							onChange={(date) => this.setState({ transferFeePaymentDate: date })}
							closeOnSelect={true}
						/>
					</FormGroup>
				</Col>
				</Row>
				<h3 className="text-dark mt-3 mb-0">Down Payments</h3>
				<Row>
					<Col>
						<FormGroup>
							<Label>Total Months</Label>
							<Input
								type="number"
								name="totalDownPaymentMonths"
								value={totalDownPaymentMonths}
								onChange={this.onChangeField}
								placeholder="Total of Months"
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col>
						<FormGroup>
							<Label>First Down Payment Date</Label>
							<Datetime
								inputProps={{
									className: "form-control",
									placeholder: "Date of down payment",
									name: "firstDownPaymentDate"
								}}
								dateFormat="MM/DD/YYYY"
								timeFormat={false}
								value={typeof firstDownPaymentDate === 'string' ? moment(firstDownPaymentDate, "MM/DD/YYYY") : firstDownPaymentDate}
								onChange={(date) => this.onChangeField({target: { value: moment(date).format("MM/DD/YYYY"), name: "firstDownPaymentDate" }})}
								closeOnSelect={true}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
                  <Col>
                    <FormGroup>
                      <Label>Principal Amount</Label>
                      <CurrencyInput 
                        name="principalAmount"
                        price={principalAmount || 0}
                        onChange={(value) => this.onChangeField({ target: { name: "principalAmount", value } })}
                        placeholder="Total amount for principal payments"
                      />
                    </FormGroup>
                  </Col>
				</Row>
				<Row>
                  <Col sm={12}>
                    <FormGroup>
                      <Label>First Check Number: Principal</Label>
                      <Input
                        type="number"
                        name="firstPrincipalCheckNumber"
                        value={firstPrincipalCheckNumber}
                        onChange={this.onChangeField}
                      />
                      <span className="form-text text-dark">
                        {`This number will be used for the first payment and subsequent payments will have +1 added to the number. Leave blank if payment method is CASH`}
                      </span>
                    </FormGroup>
                  </Col>
				</Row>
				<Row>
                  {!!firstPrincipalCheckNumber ? <Col sm={12}>
                    <FormGroup>
                      <Label>Bank Name</Label>
                      <Input
                        type="text"
                        name="firstPrincipalBankName"
                        value={firstPrincipalBankName}
                        onChange={this.onChangeField}
                      />
                    </FormGroup>
                  </Col> : null}
                </Row>
                <Row>
                  <Col sm={12}>
                    <FormGroup>
                      <Label>Misc. Amount</Label>
                      <CurrencyInput 
                        name="miscelaneousAmount"
                        price={miscelaneousAmount || 0}
                        onChange={(value) => this.onChangeField({ target: { name: "miscelaneousAmount", value } })}
                        placeholder="Total amount for miscelaneous payments"
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup>
                        <Label>First Check Number: Miselaneous</Label>
                        <Input
                          type="number"
                          name="firstMiscCheckNumber"
                          value={firstMiscCheckNumber}
                          onChange={this.onChangeField}
                        />
                        <span className="form-text text-dark">
                          {`This number will be used for the first payment and subsequent payments will have +1 added to the number. Leave blank if payment method is CASH`}
                        </span>
                    </FormGroup>
                  </Col>
                  {!!firstMiscCheckNumber ? <Col sm={12}>
                    <FormGroup>
                      <Label>Bank Name</Label>
                      <Input
                        type="text"
                        name="firstMiscBankName"
                        value={firstMiscBankName}
                        onChange={this.onChangeField}
                      />
                    </FormGroup>
                  </Col> : null}
                </Row>
                <Row>
                  <Col sm={12}>
                    <FormGroup>
                      <Label>Rental Amount</Label>
                      <CurrencyInput 
                        name="rentalAmount"
                        price={rentalAmount || 0}
                        onChange={(value) => this.onChangeField({ target: { name: "rentalAmount", value } })}
                        placeholder="Total amount for rental payments"
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup>
                        <Label>First Check Number: Rental</Label>
                        <Input
                          type="number"
                          name="firstRentalCheckNumber"
                          value={firstRentalCheckNumber}
                          onChange={this.onChangeField}
                        />
                        <span className="form-text text-dark">
                          {`This number will be used for the first payment and subsequent payments will have +1 added to the number. Leave blank if payment method is CASH`}
                        </span>
                    </FormGroup>
                  </Col>
                  {!!firstRentalCheckNumber ? <Col sm={12}>
                    <FormGroup>
                      <Label>Bank Name</Label>
                      <Input
                        type="text"
                        name="firstRentalBankName"
                        value={firstRentalBankName}
                        onChange={this.onChangeField}
                      />
                    </FormGroup>
                  </Col> : null}
                </Row>
				<h3 className="text-dark mt-3 mb-0">Balance Payments</h3>
				<Row>
					<Col>
						<FormGroup>
							<Label>Subtype</Label>
							<Select
								value={selectedBPSubtype}
								name="selectedBPSubtype"
								options={[
									{
										label: "Single",
										value: "single"
									},
									{
										label: "Multiple",
										value: "multiple"
									}
								]}
								className="basic-multi-select"
								classNamePrefix="select"
								onChange={this.onSelectChange('selectedBPSubtype')}
							/>
						</FormGroup>
					</Col>
				</Row>
				{selectedBPSubtype && selectedBPSubtype.value === "multiple" &&
					<Row>
						<Col>
							<FormGroup>
								<Label>Total Months</Label>
								<Input
									type="number"
									name="totalBalancePaymentMonths"
									value={totalBalancePaymentMonths}
									onChange={this.onChangeField}
									placeholder="Total of Months"
								/>
							</FormGroup>
							<FormGroup>
								<Label>Total Loan Interest</Label>
								<CurrencyInput 
									name="loanInterest"
									price={loanInterest || 0}
									onChange={(value) => this.onChangeField({ target: { name: "loanInterest", value } })}
									placeholder="Total Loan Insterest for all payments"
								/>
								<span className="form-text text-dark">
									{`Total will be divided equally between all payments.`}
								</span>
							</FormGroup>
						</Col>
						<Col sm={12}>
							<FormGroup>
								<Label>First Check Number</Label>
								<Input
									type="number"
									name="firstCheckNumber"
									value={firstCheckNumber}
									onChange={this.onChangeField}
								/>
								<span className="form-text text-dark">
									{`This number will be used for the first payment and subsequent payments will have +1 added to the number. Leave blank if payment method is CASH`}
								</span>
							</FormGroup>
						</Col>
					</Row>
				}
				<Row>
					<Col>
						<FormGroup>
							<Label>Total Balance Amount</Label>
							<CurrencyInput 
								name="balanceAmount"
								price={balanceAmount || 0}
								onChange={(value) => this.onChangeField({ target: { name: "balanceAmount", value } })}
								placeholder="Total amount for balance payments"
							/>
							<span className="form-text text-dark">
								{`Total will be divided equally between all payments.`}
							</span>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col>
						<FormGroup>
							<Label>{selectedBPSubtype && selectedBPSubtype.value === "multiple" ? "First Balance Payment Date" : "Balance Payment Date"}</Label>
							<Datetime
								inputProps={{
									className: "form-control",
									placeholder: "Date of balance payment",
									name: "balancePaymentDate"
								}}
								dateFormat="MM/DD/YYYY"
								timeFormat={false}
								value={typeof balancePaymentDate === 'string' ? moment(balancePaymentDate, "MM/DD/YYYY") : balancePaymentDate}
								onChange={(date) => this.onChangeField({target: { value: moment(date).format("MM/DD/YYYY"), name: "balancePaymentDate" }})}
								closeOnSelect={true}
							/>
						</FormGroup>
						{selectedBPSubtype && selectedBPSubtype.value === "multiple" &&
							<span className="form-text text-dark">
								{`Subsequent payments will be generated for the amount of months provided.`}
							</span>
						}
					</Col>
				</Row>
				{error && 
				<Alert color="danger">
					{error.message}
				</Alert>
				}
          	</Container>
        </ModalBody>
        <ModalFooter className="justify-content-end">
			<Button 
				color="primary" 
				className="btn-success-override mr-2" 
				onClick={() => onSave(saveData)}
				disabled={loading}
			>
				{loading ? "Saving" : "Save"}
			</Button>
			<Button color="secondary" className="btn-danger-override" onClick={this.toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default TransferUnitModal;